export default __webpack_public_path__ + "static/gatsby-17d3c9b5ac360c32be73381b12a5d951.png";